import { BrowserRouter } from "react-router";

import { AppErrorBoundary } from "@/components/AppErrorBoundary";
import { ThemeProvider } from "@/components/ThemeProvider";
import { I18nProvider } from "@/lib/i18n";
import { ToastProvider } from "@/components/ui/Toast";
import { SessionProvider } from "@/context/SessionContext";
import { AppRoutes } from "@/routes";

export function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <ToastProvider>
          {}
          <AppErrorBoundary>
            <SessionProvider>
              <BrowserRouter>
                <AppRoutes />
              </BrowserRouter>
            </SessionProvider>
          </AppErrorBoundary>
        </ToastProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}
